'use client';
import Hero from './hero';
import TawkTo from '../componenets/Tawko';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page() {
  return (
    <div>
      <title>Prestige Ride Terms & Conditions | Book Your Ride Today</title>
      <meta
        name="description"
        content="Review Prestige Ride's terms and conditions for using our website and services, including rights, responsibilities, and other essential information."
      />
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content="" />
      <link
        rel="canonical"
        href="https://www.prestigeride.com/terms-and-condition"
      />

      <TawkTo />
      <Navbar />
      <Hero />
      <Footer />
    </div>
  );
}

export default page;
